import { ManualMatchForm } from '@app/modules/audit/screens/matches-add/form';
import { CreateManualMatchDto } from '@app/modules/audit/types';
import { DateTimeStr } from '@mi-front/core';
import { Modal, ModalStateProps } from '@mi-front/ui';

import { FormattedMessage } from 'react-intl';
import { Station } from '@app/core/types/stations';

export interface MatchesAddScreenPropsP extends ModalStateProps {
  station: Station;
  datetime?: DateTimeStr;
  submitFn: (data: CreateManualMatchDto) => Promise<any>;
}

export function MatchesAddScreenP(props: MatchesAddScreenPropsP) {
  const { station, datetime, show, onHide, submitFn } = props;

  return (
    <Modal
      size="md"
      show={show}
      onHide={onHide}
      showCloseButton={false}
      noBody
      title={
        <div style={{ display: 'flex' }}>
          <FormattedMessage id="audit.matchesAdd.title" defaultMessage="Crear match manual" />
        </div>
      }
    >
      <ManualMatchForm station={station} datetime={datetime} submitFn={submitFn} cancel={onHide} />
    </Modal>
  );
}
